import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Api } from 'src/app/providers/app/api.prov';

@Injectable()
export class ContractProvider {
    constructor(
        public api: Api,
    ) { }

    // Consultar solicitud de constancia activa de alumno
    isSigned(controlNumber){
        return this.api.get('contracts/isSigned/'+controlNumber).pipe(map( res=>res.json()));
    }

    sign(student){
        return this.api.post('contracts/sign',student).pipe(map( res=>res.json()));
    }

    getContracts(period){
        return this.api.get('contracts/getAll/'+period).pipe(map( res=>res.json()));
    }

    getOneContract(controlNumber){
        return this.api.get('contracts/getOne/'+controlNumber).pipe(map( res=>res.json()));
    }

   }
